var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flashbuy",style:({ background: _vm.pageConfig.bgcolor })},[_c('div',{staticClass:"banner"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.pageConfig.img),expression:"pageConfig.img"}]})])])
}
var staticRenderFns = []

export { render, staticRenderFns }